module.exports = __webpack_public_path__ + "static/img/11.8b32fff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/11.png
// module id = ZnhS
// module chunks = 0